import { apiClient } from '@/api/client';
import type {
  ApiResponse,
  AuthUser,
  LoginResult,
} from '@/types/api';

export class AuthService {
  static async loginWithEmail(payload: {
    email: string;
    password: string;
    rememberMe?: boolean;
  }) {
    const { data } = await apiClient.post<ApiResponse<LoginResult>>(
      '/auth/login/email',
      payload,
    );
    return data;
  }

  static async loginWithMobile(payload: {
    mobile: string;
    password: string;
    rememberMe?: boolean;
  }) {
    const { data } = await apiClient.post<ApiResponse<LoginResult>>(
      '/auth/login/mobile',
      payload,
    );
    return data;
  }

  static async requestOtp(payload: {
    identifier: string;
    channel: 'email' | 'sms';
    purpose: 'login' | 'forgot' | 'verify';
  }) {
    const { data } = await apiClient.post<ApiResponse<{ expiresIn?: number; message?: string }>>(
      '/auth/otp/request',
      payload,
    );
    return data;
  }

  static async verifyOtp(payload: {
    identifier: string;
    code: string;
    purpose: 'login' | 'forgot' | 'verify';
    rememberMe?: boolean;
    newPassword?: string;
  }) {
    const { data } = await apiClient.post<ApiResponse<LoginResult>>(
      '/auth/otp/verify',
      payload,
    );
    return data;
  }

  static async forgotPassword(payload: {
    identifier: string;
    channel?: 'email' | 'sms';
  }) {
    const { data } = await apiClient.post<ApiResponse<{ message?: string }>>(
      '/auth/forgot-password',
      payload,
    );
    return data;
  }

  static async resetPassword(payload: {
    identifier: string;
    code: string;
    newPassword: string;
  }) {
    const { data } = await apiClient.post<ApiResponse<null>>(
      '/auth/reset-password',
      payload,
    );
    return data;
  }

  static async changePassword(payload: {
    currentPassword: string;
    newPassword: string;
  }) {
    const { data } = await apiClient.post<ApiResponse<null>>(
      '/auth/change-password',
      payload,
    );
    return data;
  }

  static async me() {
    const { data } = await apiClient.get<ApiResponse<AuthUser>>('/auth/me');
    return data;
  }

  static async logout(refreshToken?: string | null) {
    const { data } = await apiClient.post<ApiResponse<null>>('/auth/logout', {
      refreshToken: refreshToken || undefined,
    });
    return data;
  }

  static async refresh(refreshToken: string) {
    const { data } = await apiClient.post<
      ApiResponse<{ accessToken: string; refreshToken: string }>
    >('/auth/refresh', { refreshToken });
    return data;
  }
}
